import { render, staticRenderFns } from "./quanqingProduct.vue?vue&type=template&id=6c84412d&scoped=true"
import script from "./quanqingProduct.vue?vue&type=script&lang=js"
export * from "./quanqingProduct.vue?vue&type=script&lang=js"
import style0 from "./quanqingProduct.vue?vue&type=style&index=0&id=6c84412d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c84412d",
  null
  
)

export default component.exports